<template>
  <div id="app" v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  mounted(){
    this.windowResize();
  },
  methods:{
    windowResize(){
      // window.addEventListener('resize', () => {
      //   console.log(document.body.clientWidth);
      //   document
      // });
    }
  }
};
</script>

<style lang="scss">
.pl13 {
  padding-left: 20px;
}
.pc-table-color .el-table th.el-table__cell:first-child {
  
}
.pc-table-pl .el-table th.el-table__cell:first-child {
  padding-left: 20px;
}
.detail-left-height {
  height: calc(100vh - 98px);
  padding-bottom: 60px;
  overflow: auto;
}
[v-cloak] {
  display: none;
}
.el-cascader {
  width: 100%;
}
.opacity{
  animation: 0.3s 0s opacity;
}
.el-table__body-wrapper {
  overflow-y: auto !important; /* 确保可以显示垂直滚动条 */
}
@keyframes opacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.el-message {
  z-index: 10000 !important;
}

.detail .detail-main .detail-right .detail-view {
  overflow-y: auto;
  height: calc(100vh - 151px) !important;
}
.detail .detail-main .detail-left .detail-left-btn {
  position: absolute !important;
  margin-top: 0;
  bottom: 0;
}
.detail .detail-main .detail-left {
  padding-bottom: 0 !important;
  overflow-y: hidden;
}
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: contain;
}
.content {
  .content_search {
    .input_inner {
      width: 322.98px !important;
      max-width: calc((100% - 48px) / 4);
    }
    .input_inner2 {
      width: 500px !important;
      max-width: calc(((100% - 48px) / 5) * 1.5) ;
    }
  }
}
.detail .detail-main .detail-left .detail-left-list .detail-left-item div:first-child {
  flex-shrink: 0;
}
.detail .detail-main .detail-left .detail-left-list {
  padding-right: 20px;
}
.detail .detail-main .product-item .product-main .input-item .input-item-left {
  width: 73px !important;
}
.detail .detail-main .detail-left .detail-left-list .detail-left-item {
  align-items: flex-start !important;
}
.ml14 {
  margin-left: 14px;
}
.posi-center .posi-avatar .avatar-img img {
  width: 100%;
  height: 100%;
}
</style>
